import { ChangeDetectorRef, Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Address, AddressForm, AddressSuggestion, AddressTypeEnum, CorelogicService, GooglePlaceService } from 'taxtank-core';
import { AbstractFormInputComponent } from '@shared/component/form-controls/form-input/abstract-form-input/abstract-form-input.component';
import { map } from 'rxjs';
import { Observable } from 'rxjs';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'app-address-input',
  templateUrl: './address-input.component.html',
  styleUrls: ['./address-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddressInputComponent extends AbstractFormInputComponent<Address, AddressForm> implements OnInit {
  @Input() hideTypeField = true;
  @Input() hideCountryField = true;
  @Input() hideRequiredMarker: boolean;
  @Input() label = 'Street Address';
  @Input() placeholder = 'Address';
  addressTypes: typeof AddressTypeEnum = AddressTypeEnum;
  formModel: typeof AddressForm = AddressForm;
  suggestions$: Observable<any>;

  public ngControl = inject(NgControl);
  protected changeDetectorRef = inject(ChangeDetectorRef);
  private corelogicService = inject(CorelogicService);
  private googlePlaceService = inject(GooglePlaceService);

  ngOnInit(): void {
    super.ngOnInit();

    this.form.onSearch.subscribe(searchQuery => {
      this.suggestions$ = (this.form.isCorelogicAvailable() ? this.corelogicService : this.googlePlaceService).getSuggestions(searchQuery, this.form.value.country.code)
        .pipe(
          map((suggestions: AddressSuggestion[]) => {
            if (this.form.isManual) {
              this.form.onSelectSuggestion(suggestions[0]);
              this.form.get('searchQuery').setValue(suggestions[0]?.suggestion, { emitEvent: false });
            }

            return suggestions;
          })
        );
    });
  }

  /**
   * helper-function for mat-autocompleter. Display selected suggestion as human-readable string.
   */
  displaySuggestionFn(suggestionObject: AddressSuggestion | string): string {
    if (typeof suggestionObject === 'string' && !!suggestionObject) {
      return suggestionObject;
    }

    if (!suggestionObject) {
      return '';
    }

    return (suggestionObject as AddressSuggestion).suggestion;
  }
}
